/**
 * @flow
 * @relayHash 3eed877eee1385503cda7765c8a25f5c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PageCreateQueryVariables = {||};
export type PageCreateQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type PageCreateQuery = {|
  variables: PageCreateQueryVariables,
  response: PageCreateQueryResponse,
|};
*/


/*
query PageCreateQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "Query",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PageCreateQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "PageCreateQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "PageCreateQuery",
    "id": null,
    "text": "query PageCreateQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cca3bf5e03cd0481745ff7041c63b5bb';
module.exports = node;
